/**
 * Extrait la petite blind (ex: "1/2" -> 1, "0.50/1" -> 0.5).
 */
function getSmallBlind(s: string): number {
  const part = s.split('/')[0]?.trim() ?? '';
  const n = parseFloat(part);
  return Number.isNaN(n) ? 0 : n;
}

/**
 * Extrait la grosse blind (ex: "1/2" -> 2, "2/5" -> 5) pour départager à petite blind égale.
 */
function getBigBlind(s: string): number {
  const part = s.split('/')[1]?.trim() ?? '';
  const n = parseFloat(part);
  return Number.isNaN(n) ? 0 : n;
}

/**
 * Trie les limites (ex: "1/2", "2/4", "2/5", "5/10") par petite blind croissante, puis grosse blind.
 * Ainsi 2/5 est bien après 2/4 et 10/20 est en dernier.
 */
export function sortLimitsAscending(limits: string[]): string[] {
  return [...limits].sort((a, b) => {
    const sbA = getSmallBlind(a);
    const sbB = getSmallBlind(b);
    if (sbA !== sbB) return sbA - sbB;
    return getBigBlind(a) - getBigBlind(b);
  });
}

/**
 * Développe les options qui contiennent des virgules (ex: "10/20, 2/5") en limites
 * individuelles, dédoublonne et trie par ordre croissant. Pour le filtre Limites.
 */
export function expandAndSortLimitOptions(options: string[]): string[] {
  const expanded = options.flatMap((opt) =>
    opt.split(',').map((s) => s.trim()).filter(Boolean)
  );
  return sortLimitsAscending([...new Set(expanded)]);
}

/**
 * Formate une chaîne de limites (JSON array ou "a, b") pour l'affichage, triée par ordre croissant.
 * À utiliser dans les tableaux "Dernières sessions" pour la colonne Limites.
 */
export function formatStakesForDisplay(stakes: string | null): string {
  if (!stakes || !String(stakes).trim()) return '-';
  const s = String(stakes).trim();
  let arr: string[];
  try {
    const parsed = JSON.parse(s);
    arr = Array.isArray(parsed) ? parsed.map((x) => String(x).trim()).filter(Boolean) : [s];
  } catch {
    arr = s.includes(',') ? s.split(',').map((x) => x.trim()).filter(Boolean) : [s];
  }
  if (arr.length === 0) return '-';
  return sortLimitsAscending(arr).join(', ');
}
